import type { L10n, SportCategory } from '../types'

/** Sample media available to the prototype's capture / upload steps. */
export interface MediaOption {
  id: string
  url: string
  kind: SportCategory
  label: L10n
}

export const mediaLibrary: MediaOption[] = [
  {
    id: 'running',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/a2a77898-365d-42a9-bee2-a21d3c613d08.jpg',
    kind: 'running',
    label: { 'pt-BR': 'Trilha ao amanhecer', 'en-US': 'Trail at sunrise' },
  },
  {
    id: 'mindfulness',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/8f4336d0-eb2c-4f63-8c69-f7dcb72ec89b.jpg',
    kind: 'mindfulness',
    label: { 'pt-BR': 'Canto de respiração', 'en-US': 'Breathing corner' },
  },
  {
    id: 'strength',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/e5d8355f-4c16-4c72-af3a-e19dcd6b7135.jpg',
    kind: 'strength',
    label: { 'pt-BR': 'Barra carregada', 'en-US': 'Loaded barbell' },
  },
  {
    id: 'swimming',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/7c901d01-be74-41cb-b211-efa287cdd4c0.jpg',
    kind: 'swimming',
    label: { 'pt-BR': 'Raia livre', 'en-US': 'Open lane' },
  },
  {
    id: 'cycling',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/f10a209f-c2b3-4667-955a-c1a6b5e99492.jpg',
    kind: 'cycling',
    label: { 'pt-BR': 'Estrada de montanha', 'en-US': 'Mountain road' },
  },
  {
    id: 'nutrition',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/29c512ac-b4fc-470e-ae28-10cd29c2bc0b.jpg',
    kind: 'nutrition',
    label: { 'pt-BR': 'Refeição do dia', 'en-US': 'Meal of the day' },
  },
  {
    id: 'recovery',
    url: 'https://cdn.magicpatterns.com/patterns/generated-images/8fb0ba63-fe12-43d3-99f2-1ab15529779a.jpg',
    kind: 'lifestyle',
    label: { 'pt-BR': 'Recuperação em casa', 'en-US': 'Recovery at home' },
  },
]

export function mediaById(id: string): MediaOption {
  return mediaLibrary.find((item) => item.id === id) ?? mediaLibrary[0]
}
